import React from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { shouldShowField } from '../../../../components/InputField/helper';
import { variantClass } from '../../../../util/variant';

const DEFAULT_FIELD_CLASS_NAME = 'col-12';

const toTemplateKey = (field) => (typeof field === 'string' ? field.replace(/\[\d+\]/g, '[]') : field);
const arrayIndexOf = (field) => {
    const match = typeof field === 'string' ? field.match(/\[(\d+)\]/) : null;
    return match ? Number(match[1]) : undefined;
};

const normalizeTestIdSegment = (value = '') => String(value)
    .replace(/\[\]/g, '-item')
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

const BusinessV2FieldGrid = ({
    fieldOrder = [],
    fieldMap = {},
    data,
    asLabel,
    handleChange,
    hasError,
    onFieldError,
    defaultFieldClassName = DEFAULT_FIELD_CLASS_NAME,
    rowClassName = 'row gx-4 business-v2-field-grid',
    dataTestId = 'business-v2-field-grid',
    variant,
}) => {
    const orderedFields = Array.isArray(fieldOrder) ? fieldOrder : [];

    if (!orderedFields.length) {
        return null;
    }

    const gridVariantClass = variantClass(variant);

    return (
        <div className={`${rowClassName}${gridVariantClass ? ` ${gridVariantClass}` : ''}`} data-testid={dataTestId}>
            {orderedFields.map((field) => {
                const jsonField = fieldMap?.[field] ?? fieldMap?.[toTemplateKey(field)];
                if (!jsonField?.uiType) {
                    return null;
                }

                const arrayIndexing = fieldMap?.[field] ? undefined : arrayIndexOf(field);

                const fieldVariantClass = variantClass(variant, jsonField?.variant);
                // A showIf-hidden field (e.g. a "…Other" box) keeps WrapperField mounted so its
                // reset-on-hide still runs, but its column must not hold a grid slot.
                const hiddenClass = shouldShowField(data, jsonField?.showIf, arrayIndexing) ? '' : ' d-none';
                const fieldClassName = `${jsonField?.uiClassName || defaultFieldClassName} business-v2-field-grid__item${fieldVariantClass ? ` ${fieldVariantClass}` : ''}${hiddenClass}`;

                return (
                    <div
                        key={field}
                        className={fieldClassName}
                        data-testid={`${dataTestId}-${normalizeTestIdSegment(field)}`}
                    >
                        <WrapperField
                            disabled={asLabel}
                            jsonField={jsonField}
                            arrayIndexing={arrayIndexing}
                            dataObj={data}
                            onChange={handleChange}
                            showError={hasError}
                            onError={(errorMsg) => onFieldError?.(field, errorMsg)}
                            className=""
                            variant={jsonField?.variant ? [variant, jsonField.variant] : variant}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default BusinessV2FieldGrid;
